import { render, staticRenderFns } from "./AbaAnaliseComercial.vue?vue&type=template&id=58cdc69f&scoped=true"
import script from "./AbaAnaliseComercial.vue?vue&type=script&lang=js"
export * from "./AbaAnaliseComercial.vue?vue&type=script&lang=js"
import style0 from "./AbaAnaliseComercial.vue?vue&type=style&index=0&id=58cdc69f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58cdc69f",
  null
  
)

export default component.exports